class Group {
    public constructor(
        public readonly name: string,
        public readonly startingElement: number,
        public readonly operateOn: OperateOn,
        public readonly quantity: number
    ) {}
}

const OPERATE_ON = {
    HOLDING_REGISTER: 'HOLDING_REGISTER',
    DISCRETE_INPUT: 'DISCRETE_INPUT',
    COIL: 'COIL',
    INPUT_REGISTER: 'INPUT_REGISTER',
} as const

type OperateOn = keyof typeof OPERATE_ON

export { Group, OperateOn }
